import React from 'react';
import officelogo from '../../assets/images/office365-logo.png';
import officelogoShort from '../../assets/images/office3651.png';
import googlelogo from '../../assets/images/Google_Full.png';
import googlelogoShort from '../../assets/images/google_logo_.png';
import slacklogo from '../../assets/images/Slack_Full.png';
import slacklogoShort from '../../assets/images/slack-logo.png';
import atlassianlogo from '../../assets/images/atlassian.png';
import atlassianlogoShort from '../../assets/images/atlassian-logo.png';
import shopifylogo from '../../assets/images/shopify_nonplus.png';
import shopifylogoShort from '../../assets/images/shopify.webp';
import asanafulllogo from '../../assets/images/asana-full-logo.png';
import asanalogo from '../../assets/images/asana-logo.png';
import shopifypluslogo from '../../assets/images/shopify-plus-logo.png';
import shopifypluslogoShort from '../../assets/images/shopify_plus_.webp';
import githubfulllogo from '../../assets/images/github-full-logo.png';
import githublogo from '../../assets/images/github-logo.png';
import BasicSettings from './Configuration/BasicSettings/Common/basicSettings';
import BasicSettingsInformation from './Configuration/BasicSettings/Common/info&links';
import ShopifyBasicSettings from './Configuration/BasicSettings/Custom/Shopify/basicSettings';
import ShopifyPlusBasicSettings from './Configuration/BasicSettings/Custom/ShopifyPlus/basicSettings';
import CommonBasicSettings from './Edit/BasicSettings/common/basicSettings';
import EditShopifyBasicSettings from './Edit/BasicSettings/Custom/Shopify/basicSettings';
import EditShopifyPlusBasicSettings from './Edit/BasicSettings/Custom/ShopifyPlus/basicSettings';
import GroupSettings from './Configuration/AppConfiguration/ManageGroups/Common/groupSettings';
import AtlassianGroupSettings from './Configuration/AppConfiguration/ManageGroups/Atlassian/groupSettings';
import Office365GroupSettings from './Configuration/AppConfiguration/ManageGroups/Office365/groupSettings';
import EditGroupSettings from './Edit/AppConfiguration/GroupSettings/Common/commonGroupSettings';
import GroupSettingsTable from './Edit/AppConfiguration/GroupSettings/groupSettings';
import EditAtlassianGroupSettings from './Edit/AppConfiguration/GroupSettings/Custom/atlassianGroupConfiguration';
import EditOffice365GroupSettings from './Edit/AppConfiguration/GroupSettings/Custom/office365GroupConfiguration';
import ShopifyNonPlusUserConfiguration from './Configuration/AppConfiguration/UserConfiguration/ShopifyNonPlus/userConfiguration';
import SessionManagement from './Edit/SessionManagement/sessionManagement';
import OfficeInfo from './Custom/office';
import SingletonAppGroupSettings from './Configuration/AppConfiguration/ManageGroups/Common/SingletonAppGroupSettings';
import DeviceManagement from './Edit/DeviceManagement/deviceManagement';
import Application from './application';

const commonEditScnComponents = {
  basicSettings: <CommonBasicSettings />,
  groupSettings: <GroupSettingsTable />,
  groupAppSettings: <SingletonAppGroupSettings editScreen />,
  session: <SessionManagement />,
  deviceManagement: <DeviceManagement />,
};

const configCommonComponent = {
  basicSettingScreen: <BasicSettings />,
  basicSettingsInfo: <BasicSettingsInformation />,
  groupSettingScreen: <SingletonAppGroupSettings editScreen={false} />,
};

export const apps = {
  [process.env.REACT_APP_OFFICE365_KEY!]: {
    path: '/casb/office365',
    logo: officelogo,
    smallLogo: officelogoShort,
    appConfigurationTitle: 'Group Settings',
    title: 'Office365',
    isSingletonApplication: false,
    mainComponent: <Application app={process.env.REACT_APP_OFFICE365_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
      groupSettingScreen: <Office365GroupSettings />,
    },
    editScreen: {
      basicSettings: <CommonBasicSettings />,
      groupSettings: <GroupSettingsTable />,
      groupAppSettings: <EditOffice365GroupSettings />,
      session: <SessionManagement />,
      deviceManagement: <DeviceManagement />,
    },
    appConfiguration: <OfficeInfo />,
    guide:
      'https://www.miniorange.com/casb/integrations/how-to-setup-microsoft-365-with-casb-solution',
  },
  [process.env.REACT_APP_GOOGLE_KEY!]: {
    path: '/casb/google',
    logo: googlelogo,
    smallLogo: googlelogoShort,
    appConfigurationTitle: 'Group Settings',
    title: 'Google',
    isSingletonApplication: false,
    mainComponent: <Application app={process.env.REACT_APP_GOOGLE_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
      groupSettingScreen: <GroupSettings />,
    },
    editScreen: {
      ...commonEditScnComponents,
      groupAppSettings: <EditGroupSettings />,
    },
    guide:
      'https://www.miniorange.com/casb/integrations/how-to-setup-casb-for-google-workspace-apps',
  },
  [process.env.REACT_APP_ATLASSIAN_KEY!]: {
    path: '/casb/atlassian',
    logo: atlassianlogo,
    smallLogo: atlassianlogoShort,
    appConfigurationTitle: 'Group Settings',
    title: 'Atlassian',
    isSingletonApplication: false,
    mainComponent: <Application app={process.env.REACT_APP_ATLASSIAN_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
      groupSettingScreen: <AtlassianGroupSettings />,
    },
    editScreen: {
      ...commonEditScnComponents,
      groupAppSettings: <EditAtlassianGroupSettings />,
    },
    guide:
      'https://www.miniorange.com/casb/integrations/how-to-setup-casb-for-atlassian',
  },
  [process.env.REACT_APP_SHOPIFY_NON_PLUS_KEY!]: {
    path: '/casb/shopify',
    logo: shopifylogo,
    smallLogo: shopifylogoShort,
    appConfigurationTitle: 'Groups & User Configuration',
    title: 'Shopify',
    isSingletonApplication: true,
    mainComponent: (
      <Application app={process.env.REACT_APP_SHOPIFY_NON_PLUS_KEY!} />
    ),

    configurationScreen: {
      basicSettingScreen: <ShopifyBasicSettings />,
      basicSettingsInfo: <BasicSettingsInformation showIdpMetadata={false} />,
      groupSettingScreen: <ShopifyNonPlusUserConfiguration />,
    },
    editScreen: {
      basicSettings: <EditShopifyBasicSettings />,
      groupSettings: <ShopifyNonPlusUserConfiguration />,
      session: <SessionManagement />,
    },
    guide:
      'https://www.miniorange.com/casb/integrations/how-to-setup-casb-for-shopify-non-plus',
  },
  [process.env.REACT_APP_SHOPIFY_PLUS_KEY!]: {
    path: '/casb/shopify-plus',
    logo: shopifypluslogo,
    smallLogo: shopifypluslogoShort,
    appConfigurationTitle: 'Group Settings',
    title: 'Shopify +',
    isSingletonApplication: true,
    mainComponent: (
      <Application app={process.env.REACT_APP_SHOPIFY_PLUS_KEY!} />
    ),
    configurationScreen: {
      ...configCommonComponent,
      basicSettingScreen: <ShopifyPlusBasicSettings />,
    },
    editScreen: {
      ...commonEditScnComponents,
      basicSettings: <EditShopifyPlusBasicSettings />,
    },
    guide:
      'https://www.miniorange.com/casb/integrations/how-to-setup-casb-for-shopify-plus',
  },
  [process.env.REACT_APP_GITHUB_KEY!]: {
    path: '/casb/github',
    logo: githubfulllogo,
    smallLogo: githublogo,
    appConfigurationTitle: 'Group Settings',
    title: 'GitHub',
    isSingletonApplication: true,
    mainComponent: <Application app={process.env.REACT_APP_GITHUB_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
    },
    editScreen: {
      ...commonEditScnComponents,
    },
    guide: '',
  },
  [process.env.REACT_APP_SLACK_KEY!]: {
    path: '/casb/slack',
    logo: slacklogo,
    smallLogo: slacklogoShort,
    appConfigurationTitle: 'Group Settings',
    title: 'Slack',
    isSingletonApplication: true,
    mainComponent: <Application app={process.env.REACT_APP_SLACK_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
    },
    editScreen: {
      ...commonEditScnComponents,
    },
    guide: '',
  },
  [process.env.REACT_APP_SLACK_KEY!]: {
    path: '/casb/slack',
    logo: slacklogo,
    smallLogo: slacklogoShort,
    appConfigurationTitle: 'Group Settings',
    title: 'Slack',
    isSingletonApplication: true,
    mainComponent: <Application app={process.env.REACT_APP_SLACK_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
    },
    editScreen: {
      ...commonEditScnComponents,
    },
    guide: '',
  },
  [process.env.REACT_APP_ASANA_KEY!]: {
    path: '/casb/asana',
    logo: asanafulllogo,
    smallLogo: asanalogo,
    appConfigurationTitle: 'Group Settings',
    title: 'Asana',
    isSingletonApplication: true,
    mainComponent: <Application app={process.env.REACT_APP_ASANA_KEY!} />,
    configurationScreen: {
      ...configCommonComponent,
    },
    editScreen: {
      ...commonEditScnComponents,
    },
    guide: '',
  },
};
